// One upload step for every build picture (cart, Save Build, share image, My Builds).
// It returns the picture's link only once Cloudflare has confirmed the upload, and tries once more with a
// fresh upload link if the first attempt fails (weak signal, a timeout, a server hiccup). Before this,
// each caller used the link even when the upload had failed, so the build ended up pointing at a picture
// that doesn't exist and showed an empty photo in the cart and My Builds. On failure it returns '' so the
// caller leaves the picture out (the cart then falls back to the product photo).
const CF_URL_ENDPOINT = 'https://customizer-test-nodejs-4c6a5bfd6dbd.herokuapp.com/api/cf-images-upload-url'

const withTimeout = (ms) => {
  const ctl = new AbortController()
  const t = setTimeout(() => ctl.abort(), ms)
  return { signal: ctl.signal, done: () => clearTimeout(t) }
}

export async function uploadToCloudflare(blob, filename, opts = {}) {
  const { attempts = 2, uploadTimeoutMs = 15000, uploadUrl: firstUploadUrl, imageUrl: firstImageUrl } = opts
  if (!blob) return ''
  for (let i = 0; i < attempts; i++) {
    try {
      let uploadUrl = i === 0 ? firstUploadUrl : null
      let imageUrl = i === 0 ? firstImageUrl : null
      if (!uploadUrl || !imageUrl) {
        const t = withTimeout(8000)
        const res = await fetch(CF_URL_ENDPOINT, { signal: t.signal }).finally(t.done)
        if (!res.ok) throw new Error('upload link HTTP ' + res.status)
        const data = await res.json()
        uploadUrl = data.uploadUrl
        imageUrl = data.imageUrl
        if (!uploadUrl || !imageUrl) throw new Error('no upload link returned')
      }
      const form = new FormData()
      form.append('file', blob, filename)
      const t = withTimeout(uploadTimeoutMs)
      const up = await fetch(uploadUrl, { method: 'POST', body: form, signal: t.signal }).finally(t.done)
      if (up.ok) return imageUrl
      throw new Error('upload HTTP ' + up.status)
    } catch (e) {
      if (i < attempts - 1) await new Promise((r) => setTimeout(r, 800))
      else console.warn('[cf-upload] picture upload failed:', e?.message || e)
    }
  }
  return ''
}
